import React, {useContext, useState} from 'react';
import {Button, ConfirmationButton, SegmentedButton} from "@dts-soldel/dts-react-common";
import ConfiguratorInputs from "./Input/ConfiguratorInputs";
import ConfiguratorOutput from "./Output/ConfiguratorOutput";
import MobXContext from "../../app/mobx/MobXContext";
import {utahHeaderLoaded} from "../UtahHeader/UtahHeader";
import {observer} from "mobx-react";
import LocalStorage from "../../app/localstorage/LocalStorage";
import Pages from "../../app/pages/Pages";
import ConfiguratorMenu from "./Menu/ConfiguratorMenu";
import ConfigurationTypes from "./ConfigurationTypes";

const propTypes = {};
const defaultProps = {};

const Configurator = () => {
	const {configuratorStore} = useContext(MobXContext);
	const [h1Height, setH1Height] = useState(NaN);
	const [headerHeight, setHeaderHeight] = useState(NaN);
	const [configurationType, setConfigurationType] = useState(LocalStorage.configuratorType.get(ConfigurationTypes.header));
	useState(() => {
		// create observer
		const resizeObserver = new ResizeObserver(entries => {
			if (entries.length > 1) {
				console.error('ResizeObserver coded for only one entry...');
			}

			setHeaderHeight(
				entries[0].contentBoxSize ?
					entries[0].contentBoxSize[0].blockSize :
					entries[0].contentRect.height
			);

			// render configurator content in sized area
			const h1 = document.querySelector('.configurator h1');
			setH1Height(h1.offsetHeight + Number((h1.currentStyle || window.getComputedStyle(h1)).marginBottom.slice(0, -2)));
		});

		// setup watching for header size changes
		utahHeaderLoaded.then(() => resizeObserver.observe(
			document.getElementsByClassName('utah-gov-header')[0])
		);

		return resizeObserver;
	});

	// update react-app to adjusted size with header
	document.getElementsByClassName('react-app')[0].style.height = (
		`calc(100% - ${headerHeight}px ${
			configuratorStore.modifierClasses.includes('sticky') ? ' + 200px' : ''
		})`
	);

	return (
		<div className="configurator">
			<h1 className="bg-primary color-white text-center mb-zero"><span className="content">Utah Header Configuration Tool</span></h1>
			<div className="configurator__content" style={{height: `calc(100% - ${h1Height}px)`}}>
				<div className="configurator__content__panel-left">
					<div className="configurator__content__panel-left__top">
						<Button
							label="Style Guide"
							onClick={() => Pages.public.styleGuide.forward()}
							className="complementary button--solid"
						/>
						<Button
							label="react"
							onClick={() => Pages.public.reactComponent.forward()}
							className="neutral button--solid"
						/>
						<Button
							label="changelog"
							onClick={() => Pages.public.changeLog.forward()}
							className="neutral button--solid"
						/>
						<ConfirmationButton
							onConfirm={configuratorStore.reset}
							initialLabel="clear"
							promptLabel="Are you sure?"
							className="neutral button--solid"
						/>
					</div>
					<SegmentedButton
						field="configurationType"
						label="Configuration Type"
						className="segmented-button full-width"
						options={[
							{value: ConfigurationTypes.header, label: 'Header'},
							{value: ConfigurationTypes.menu, label: 'Menu'},
						]}
						value={configurationType}
						showLabel={false}
						onChange={(field, value) => {
							setConfigurationType(value);
							LocalStorage.configuratorType.set(value);
						}}
					/>
					{configurationType === ConfigurationTypes.header ? <ConfiguratorInputs/> : undefined}
					{configurationType === ConfigurationTypes.menu ? <ConfiguratorMenu/> : undefined}
				</div>
				<div className="configurator__content__panel-right">
					<ConfiguratorOutput configurationType={configurationType}/>
				</div>
			</div>
		</div>
	);
};

Configurator.propTypes = propTypes;
Configurator.defaultProps = defaultProps;

export default observer(Configurator);
